import { ThemeEvents, CartAddEvent, CartErrorEvent, VariantUpdateEvent } from '@theme/events';
class SubscriptionBundle extends HTMLElement {
    constructor() {
        super();
        this.totalQuantity = 0;
        this.minQuantity = Number(this.querySelector(".bundle-subscription-wrapper").dataset.minQuantity) || 4;
    }

    connectedCallback() {
        this.initFlavorButtons();
        this.initPlanBoxSelection();
        this.initSubscriptionRadio();
        this.initSubscribeSaveClick();
        this.checkSubscriptionEligibility();
        this.initTooltipToggle();
        this.debouncedInjectBundleInputs = debounce(this.injectBundleInputsToForm.bind(this), 200);
        this.applyPreselectFromURL();


        const atcButton = document.querySelector("#bundle-atc-button")
        // this.removeDefaultShopifyInput();
        if (atcButton) {
            atcButton.addEventListener('click', async (e) => {
                e.preventDefault();

                const spinner = atcButton.querySelector('.spinner');
                const atcText = atcButton.querySelector('.add-to-cart-text__content');
                atcText.style.display = 'none';
                spinner.classList.remove('hidden');


                const isSubscription = this.querySelector('input[value="subscription"]')?.checked;
                let cartItems = [];
                const { bundleId, parentHandle, parentVariantId } = await this.getBundleMeta();
                if (isSubscription) {
                    const { bundle, bundleProductData } = this.buildRechargeBundle();
                    cartItems = await recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
                } else {
                   const { items } = this.prepareCartItems();
                    cartItems = items;
                    // Add bundle meta so OTP behaves like bundled cart rows without using RC keys
                    cartItems = cartItems.map(item => ({
                        ...item,
                        properties: {
                            ...item.properties,
                            _bundle: true,
                            // _otp_bundle: bundleId,
                            // _otp_bundle_parent: parentHandle,
                            // _otp_bundle_variant: parentVariantId
                        }
                    }));
                }
                const cartData = { items: cartItems };

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(cartData) // send item array directly
                })
                    .then(res => res.json())
                    .then((data) => console.log("bundle added"))
                    .catch(err => {
                        console.error('Error adding to cart:', err);
                    }).finally(() => {
                        spinner.classList.add('hidden');
                        atcText.style.display = 'block';
                        console.log('Bundle added to cart');
                        const productForm = document.querySelector('product-form-component');
                        if (!productForm) return;
                        this.dispatchEvent(
                            new CartAddEvent({}, productForm.id, {
                                didError: false,
                                source: 'product-form-component',
                                itemCount: Number(productForm.dataset.quantityDefault),
                                productId: productForm.dataset.productId,
                            })
                        );
                    });
            });
        }

    }

    initTooltipToggle() {
        const tooltipBtn = this.querySelector('.tooltip-btn');
        if (!tooltipBtn) return;

        const tooltipIcon = tooltipBtn.querySelector('.tooltip-icon');
        const tooltipCloseIcon = tooltipBtn.querySelector('.tooltip-close-icon');
        const tooltipContent = this.querySelector('.tooltip-content');
        const noteWrapper = this.querySelector('.qunaity-limit-note');


        const showTooltip = () => {
            tooltipContent.style.display = 'block';
            tooltipIcon.style.display = 'none';
            tooltipCloseIcon.style.display = 'block';
            noteWrapper?.classList.add('open');
        };

        const hideTooltip = () => {
            tooltipContent.style.display = 'none';
            tooltipIcon.style.display = 'block';
            tooltipCloseIcon.style.display = 'none';
            noteWrapper?.classList.remove('open');
        };

        tooltipIcon.addEventListener('click', showTooltip);
        tooltipCloseIcon.addEventListener('click', hideTooltip);

        // Initial state
        tooltipContent.style.display = 'none';
        tooltipCloseIcon.style.display = 'none';
    }


    prepareCartItems() {
        const selectedPlanName = this.getSelectedSellingPlanName();
        const isSubscription = this.querySelector('input[value="subscription"]')?.checked;

        const items = [];
        let totalPrice = 0;
        let globalDiscount = 0;

        // Step 1: Get global discount from the first valid product
        if (isSubscription && selectedPlanName) {
            const firstProductEl = document.querySelector('.Meta_stitch_product_list_innerloops_mainboxs_new[data-selling-plans]');
            if (firstProductEl) {
                try {
                    const plans = JSON.parse(firstProductEl.getAttribute('data-selling-plans') || '[]');
                    const match = plans.find(p => p.name === selectedPlanName);
                    if (match?.discount) {
                        globalDiscount = match.discount;
                    }
                } catch (err) {
                    console.warn('Invalid global selling plan JSON', err);
                }
            }
        }

        // Step 2: Build item list
        document.querySelectorAll('.Meta_stitch_product_list_innerloops_mainboxs_new').forEach(productEl => {
            const qtyBox = productEl.querySelector('.Meta_stitch_product_list_quantity_selector');
            if (!qtyBox) return;

            const quantity = parseInt(qtyBox.dataset.quantity || '0', 10);
            if (quantity < 1) return;

            const variantId = productEl.dataset.variantId;
            const basePrice = parseInt(productEl.dataset.variantPrice || '0', 10); // in paise 

            // Apply global discount
            const finalUnitPrice = isSubscription && globalDiscount
                ? basePrice * (1 - globalDiscount / 100)
                : basePrice;

            totalPrice += finalUnitPrice * quantity;

            const item = {
                id: variantId,
                quantity,
            };

            // Add selling plan if applicable
            if (isSubscription && selectedPlanName) {
                const planId = this.getProductSellingPlanId(productEl, selectedPlanName);
                if (planId) {
                    item.selling_plan = planId;
                }
            }

            items.push(item);
        });

        return { items, totalPrice };
    }

    buildRechargeBundle() {
        const selections = [];
        const selectedPlanName = this.getSelectedSellingPlanName();
        const isSubscription = this.querySelector('input[value="subscription"]')?.checked;

        // ✅ Parent Bundle Product Info — for Recharge
        const bundleProductId = document.querySelector(".Meta_stitch_product_list_innerloops_new").dataset.parentId;
        const bundleVariantId = document.querySelector(".Meta_stitch_product_list_innerloops_new").dataset.parentVariantId;
        const bundleHandle = "origin-satiety-complex"; // Or dynamically pulled if needed

        // ✅ Loop through child product selections
        document.querySelectorAll('.Meta_stitch_product_list_innerloops_mainboxs_new').forEach(productEl => {
            const qtyBox = productEl.querySelector('.Meta_stitch_product_list_quantity_selector');
            if (!qtyBox) return;

            const quantity = parseInt(qtyBox.dataset.quantity || '0', 10);
            if (quantity < 1) return;

            const externalProductId = productEl.dataset.productId;
            const externalVariantId = productEl.dataset.variantId;
            const collectionId = productEl.getAttribute('collection-id');

            const selection = {
                collectionId,
                externalProductId,
                externalVariantId,
                quantity,
            };

            if (isSubscription && selectedPlanName) {
                const planId = this.getProductSellingPlanId(productEl, selectedPlanName);
                if (planId) {
                    selection.sellingPlan = planId;
                }
            }

            selections.push(selection);
        });

        // ✅ Bundle product details go in this object
        const bundleProductData = {
            // productId: bundleProductId,         // 🔵 Parent Product ID
            // variantId: bundleVariantId,         // 🔵 Parent Variant ID
            // handle: bundleHandle,               // 🔵 Parent Product handle
            // sellingPlan: "11909628215", 

            productId: "10248802304311",         // 🔵 Parent Product ID
            variantId: "50905002344759",         // 🔵 Parent Variant ID
            handle: "bundle",                    // 🔵 Parent Product handle
            sellingPlan: "11909628215",
        };

        // ✅ Final Recharge bundle object
        const bundle = {
            externalProductId: "10248802304311",     // 🔵 Parent
            externalVariantId: "50905002344759",     // 🔵 Parent
            selections                               // 🔴 Children
        };

        return { bundle, bundleProductData };
    }

    removeDefaultShopifyInput() {
        console.log(123123);
        const form = document.querySelector('form.shopify-product-form');
        if (!form) return;

        const defaultIdInput = form.querySelector('input[name="id"][ref="variantId"]');
        if (defaultIdInput) {
            defaultIdInput.disabled = true;
            // return null 
        }
    }

    injectBundleInputsToForm() {
        const { items, totalPrice } = this.prepareCartItems();
        this.updateDisplayedPrices(items);
        this.updateATCButtonState(items.length > 0, totalPrice);
    }

    updateDisplayedPrices(items) {
        const discountedPriceDiv = this.querySelector('[discounted-price]');
        const originalPriceDiv = this.querySelector('[original-price]');
        const isSubscription = this.querySelector('input[value="subscription"]')?.checked;
        const selectedPlanName = this.getSelectedSellingPlanName();

        let totalOriginal = 0;
        let totalDiscounted = 0;

        if (items.length === 0) {
            // 👉 fallback to default (initial) price behavior
            const firstProductEl = this.querySelector('[data-variant-price]');
            if (firstProductEl) {
                const basePrice = parseFloat(firstProductEl.getAttribute('data-variant-price') || '0') / 100;
                const discountPercent = 10; // default fallback discount
                const discounted = basePrice * (1 - discountPercent / 100);
                originalPriceDiv.innerHTML = window.currenctSymbol + basePrice.toFixed(2);
                discountedPriceDiv.innerHTML = `${window.currenctSymbol + discounted.toFixed(2)} <s>${window.currenctSymbol + basePrice.toFixed(2)}</s>`;
            }
            return;
        }

        // 🟢 If quantity exists, calculate normally
        items.forEach(item => {
            const productEl = document.querySelector(`[data-variant-id="${item.id}"]`);
            if (!productEl) return;

            const unitPrice = parseFloat(productEl.getAttribute('data-variant-price') || '0') / 100;
            const qty = parseInt(item.quantity, 10);
            const baseTotal = unitPrice * qty;
            let discountedTotal = baseTotal;

            let discount = 0;
            if (isSubscription && selectedPlanName) {
                try {
                    const plans = JSON.parse(productEl.getAttribute('data-selling-plans') || '[]');
                    const match = plans.find(p => p.name === selectedPlanName);
                    if (match?.discount) discount = match.discount;
                } catch (e) {
                    console.warn('Invalid selling plan data', e);
                }
            } else {
                discount = 10; // fallback discount for display if subscription is not selected
            }

            discountedTotal = baseTotal * (1 - discount / 100);

            totalOriginal += baseTotal;
            totalDiscounted += discountedTotal;
        });

        if (totalOriginal > 0) {
            originalPriceDiv.innerHTML = `${window.currenctSymbol + totalOriginal.toFixed(2)}`;
            discountedPriceDiv.innerHTML = `${window.currenctSymbol + totalDiscounted.toFixed(2)} <s>${window.currenctSymbol + totalOriginal.toFixed(2)}</s>`;
        } else {
            // Fallback for 0 quantity
            const fallback = parseInt(this.querySelector('[discounted-price]')?.dataset.basePrice || '0', 10) / 100;
            const discounted = fallback * 0.9; // default 10% off
            discountedPriceDiv.innerHTML = `${window.currenctSymbol + discounted} <s>${window.currenctSymbol + fallback}</s>`;
        }
    }

    updateSubscribeDiscountText() {
        const selectedPlanName = this.getSelectedSellingPlanName();
        const discountSpan = this.querySelector('.subscribe-discount');

        if (!selectedPlanName || !discountSpan) return;

        // Use the first active product to extract the plan discount
        const firstProduct = document.querySelector('[data-selling-plans]');
        if (!firstProduct) return;

        try {
            const plans = JSON.parse(firstProduct.getAttribute('data-selling-plans') || '[]');
            const match = plans.find(p => p.name === selectedPlanName);
            if (match?.discount) {
                discountSpan.textContent = `${match.discount}%`;
            }
        } catch (err) {
            console.warn('Failed to parse selling plans', err);
        }
    }

    updateATCButtonState(isEnabled) {
        const atcBtn = document.querySelector('.bundle-atc-btn');
        const labelSpan = atcBtn?.querySelector('.add-to-cart-text__content');
        const { items, totalPrice } = this.prepareCartItems();

        if (!atcBtn || !labelSpan) return;

        if (!isEnabled) {
            atcBtn.setAttribute('disabled', 'true');
            labelSpan.textContent = 'SELECT A FLAVOR';
        } else {
            atcBtn.removeAttribute('disabled');
            // const formattedPrice = `${(window.currenctSymbol + totalPrice / 100)}`;
            // labelSpan.textContent = `Add to cart – ${formattedPrice}`;

            const price = totalPrice / 100;
            let formattedPrice;

            const currencySymbol = `${(window.currenctSymbol)}`;

            if (price % 1 === 0) {
            formattedPrice = currencySymbol + price.toFixed(0);
            } else {
            formattedPrice = currencySymbol + price.toFixed(2);
            }

            labelSpan.textContent = `Add to cart – ${formattedPrice}`;
        }
    }

    async getBundleMeta() {
        let existingId = null;
        try {
            const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
            const cart = await res.json();
            const found = cart.items.find((ci) => ci.properties && ci.properties._otp_bundle);
            existingId = found?.properties?._otp_bundle || null;
        } catch (err) {
            console.warn('Could not read cart for OTP bundle reuse', err);
        }

        const wrapper = this.querySelector('.bundle-subscription-wrapper');
        return {
            bundleId: existingId || `otp-${Date.now()}`,
            parentHandle: wrapper?.dataset.parentHandle || 'bundle',
            parentVariantId: wrapper?.dataset.parentVariantId || '50905002344759',
            parentProductId: wrapper?.dataset.parentId || '10248802304311',
        };
    }

    initFlavorButtons() {
        document.querySelectorAll('.Meta_stitch_product_list_add_flavor_new').forEach((button) => {
            const bottomBox = button.closest('.Meta_stitch_product_list_innerloops_mainboxs_bottom_new');
            if (!bottomBox) return;

            button.addEventListener('click', (e) => {
                e.stopPropagation();
                this.replaceWithQuantitySelector(button);
            });
        });
    }

    replaceWithQuantitySelector(button) {
        const parent = button.parentNode;
        const bottomBox = parent?.closest('.Meta_stitch_product_list_innerloops_mainboxs_bottom_new');
        const productEl = bottomBox?.closest('.Meta_stitch_product_list_innerloops_mainboxs_new');

        if (parent.querySelector('.Meta_stitch_product_list_quantity_selector')) return;

        const quantityWrapper = document.createElement('div');
        quantityWrapper.className = 'Meta_stitch_product_list_quantity_selector';
        quantityWrapper.dataset.quantity = "1";
        quantityWrapper.innerHTML = `
          <button class="decrease"">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="2" viewBox="0 0 15 2" fill="none">
                 <path d="M14.5 1.14062L0.5 1.14062" stroke="#FFFDF4" stroke-linecap="square"/>
            </svg>
          </button>
          <span class="quantity">1</span>
          <button class="increase">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M7.83203 1.14062L7.83203 15.1406" stroke="#FFFDF4" stroke-linecap="square"/>
                <path d="M14.832 8.14062H0.832031" stroke="#FFFDF4" stroke-linecap="square"/>
            </svg>
          </button>
        `;

        parent.replaceChild(quantityWrapper, button);

        this.totalQuantity += 1;
        productEl.classList.add('active'); // ✅ Add here
        this.checkSubscriptionEligibility();
        this.debouncedInjectBundleInputs();

        const quantityText = quantityWrapper.querySelector('.quantity');

        // INCREASE
        quantityWrapper.querySelector('.increase').addEventListener('click', () => {
            let qty = parseInt(quantityWrapper.dataset.quantity, 10);
            qty++;
            quantityWrapper.dataset.quantity = qty;
            quantityText.textContent = qty;

            this.totalQuantity++;
            productEl.classList.add('active'); // ✅ Ensure it stays active
            this.checkSubscriptionEligibility();
            this.debouncedInjectBundleInputs();
        });

        // DECREASE
        quantityWrapper.querySelector('.decrease').addEventListener('click', () => {
            let qty = parseInt(quantityWrapper.dataset.quantity, 10);

            if (qty > 1) {
                qty--;
                quantityWrapper.dataset.quantity = qty;
                quantityText.textContent = qty;

                this.totalQuantity--;
                if (qty === 1) productEl.classList.add('active'); // still active
                this.checkSubscriptionEligibility();
                this.debouncedInjectBundleInputs();
            } else {
                // Reset to Add Flavor
                quantityWrapper.remove();
                const newButton = this.buildAddFlavorButton();
                parent.appendChild(newButton);
                this.initFlavorButtons();

                this.totalQuantity--;
                productEl.classList.remove('active'); // ✅ Remove when 0
                this.checkSubscriptionEligibility();
                this.debouncedInjectBundleInputs();
            }
        });
    }

    buildAddFlavorButton() {
        const button = document.createElement('div');
        button.className = 'Meta_stitch_product_list_add_flavor_new';
        button.innerHTML = `
        <span>ADD FLAVOR</span>
        <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0" y="0" width="35" height="35" fill="#212121"></rect>
          <rect x="0" y="0" width="35" height="35" stroke="#212121"></rect>
          <path d="M17.834 10.5V24.5" stroke="#FFFDF4" stroke-linecap="square"></path>
          <path d="M24.834 17.5H10.834" stroke="#FFFDF4" stroke-linecap="square"></path>
        </svg>
      `;
        return button;
    }

    checkSubscriptionEligibility() {
        const subscribeRadio = this.querySelector('input[value="subscription"]');
        const oneTimeRadio = this.querySelector('input[value="onetime"]');
        const planBoxContainer = this.querySelector('.selling-plan-boxes');
        const note = this.querySelector('.tooltip-note');
        const atcButton = document.querySelector('.bundle-atc-btn');
        const atcButtonText = atcButton?.querySelector('.add-to-cart-text__content');
        const remaining = Math.max(this.minQuantity - this.totalQuantity, 0);
        const noteWrapper = this.querySelector('.qunaity-limit-note');
        const oneTimeWrapper = this.querySelector('.one-time-purhcase-wrapper');
        // 🟡 Show/hide note
        if (note) {
            note.parentElement.style.display = remaining > 0 ? 'flex' : 'none';
            noteWrapper.style.display = remaining > 0 ? 'block' : 'none';
            note.textContent = `Select ${remaining} more pouch(es) to unlock subscription perks`;
        }

        const { items, totalPrice } = this.prepareCartItems();
        this.updateATCButtonState(items.length > 0, totalPrice);

        // 🟥 ATC Button logic
        if (this.totalQuantity < 1) {
            atcButton?.setAttribute('disabled', 'true');
            if (atcButtonText) atcButtonText.textContent = 'SELECT A FLAVOR';
        } else {
            atcButton?.removeAttribute('disabled');
            if (atcButtonText) {
                const formattedPrice = (totalPrice / 100)
                atcButtonText.textContent = `Add to cart - ${formattedPrice}`;
            }
        }

        // 💡 Subscription enable logic
        if (this.totalQuantity >= this.minQuantity) {
            if (subscribeRadio.checked) {
                planBoxContainer.classList.remove('disabled');
            } else {
                planBoxContainer.classList.add('disabled');
                this.clearPlanBoxSelection();
            }
        } else {
            oneTimeRadio.checked = true;
            oneTimeWrapper.classList.add("active");
            planBoxContainer.classList.add('disabled');
            this.clearPlanBoxSelection();
        }
    }

    getSelectedSellingPlanName() {
        const checked = this.querySelector('.plan-box input:checked');
        return checked ? checked.value : null;
    }

    getProductSellingPlanId(productEl, selectedPlanName) {
        try {
            const plansJson = productEl.getAttribute('data-selling-plans');
            const plans = JSON.parse(plansJson);
            const match = plans.find(p => p.name === selectedPlanName);
            return match ? match.id : null;
        } catch (err) {
            console.warn("Invalid or missing selling plan on product:", err);
            return null;
        }
    }

    clearPlanBoxSelection() {
        this.querySelectorAll('.plan-box input').forEach(input => input.checked = false);
        this.querySelectorAll('.plan-box').forEach(box => box.classList.remove('active'));
    }

    initSubscriptionRadio() {
        const subscribeRadio = this.querySelector('input[value="subscription"]');
        const oneTimeRadio = this.querySelector('input[value="onetime"]');
        const oneTimeWrapper = this.querySelector('.one-time-purhcase-wrapper');
        const subscribeWrapper = this.querySelector('.subscribe-save-wrapper');

        const updateWrapperClass = () => {
            if (subscribeRadio.checked) {
                subscribeRadio?.classList.add('checked');
                subscribeWrapper?.classList.add('active');
            } else {
                subscribeRadio?.classList.remove('checked');
                subscribeWrapper?.classList.remove('active');
            }

            if (oneTimeRadio.checked) {
                oneTimeRadio?.classList.add('checked');
                oneTimeWrapper?.classList.add('active');
            } else {
                oneTimeRadio?.classList.remove('checked');
                oneTimeWrapper?.classList.remove('active');
            }
        };

        // Initial sync
        updateWrapperClass();

        subscribeRadio.addEventListener('change', () => {
            if (subscribeRadio.checked && this.totalQuantity < this.minQuantity) {
                this.ensureFirstBundleQuantity(this.minQuantity);
            }
            this.checkSubscriptionEligibility();

            // Auto-select first subscription plan
            if (subscribeRadio.checked && this.totalQuantity >= this.minQuantity) {
                const firstPlanInput = this.querySelector('.plan-box input');
                if (firstPlanInput && !firstPlanInput.checked) {
                    firstPlanInput.checked = true;
                    firstPlanInput.dispatchEvent(new Event('click', { bubbles: true })); // ✅ Triggers plan box logic
                }
            }

            updateWrapperClass();
            this.debouncedInjectBundleInputs();
            this.updateSubscribeDiscountText();
        });

        oneTimeRadio.addEventListener('change', () => {
            this.clearPlanBoxSelection();
            this.checkSubscriptionEligibility();
            updateWrapperClass();
            this.debouncedInjectBundleInputs();
        });
    }

    initSubscribeSaveClick() {
        const subscribeSaveText = this.querySelector('.subscribe-save-text');
        if (!subscribeSaveText) return;

        subscribeSaveText.addEventListener('click', () => {
            const subscribeRadio = this.querySelector('input[value="subscription"]');
            if (!subscribeRadio) return;

            if (this.totalQuantity < this.minQuantity) {
                this.ensureFirstBundleQuantity(this.minQuantity);
            }

            subscribeRadio.checked = true;
            subscribeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    ensureFirstBundleQuantity(targetQty) {
        const firstProduct = document.querySelector('.Meta_stitch_product_list_innerloops_mainboxs_new');
        if (!firstProduct) return;

        let qtyBox = firstProduct.querySelector('.Meta_stitch_product_list_quantity_selector');
        if (!qtyBox) {
            const addBtn = firstProduct.querySelector('.Meta_stitch_product_list_add_flavor_new');
            if (addBtn) this.replaceWithQuantitySelector(addBtn);
            qtyBox = firstProduct.querySelector('.Meta_stitch_product_list_quantity_selector');
        }
        if (!qtyBox) return;

        const current = parseInt(qtyBox.dataset.quantity || '0', 10);
        if (current === targetQty) return;

        qtyBox.dataset.quantity = String(targetQty);
        const qtyText = qtyBox.querySelector('.quantity');
        if (qtyText) qtyText.textContent = String(targetQty);

        this.totalQuantity += (targetQty - current);
        firstProduct.classList.add('active');
    }

    initPlanBoxSelection() {
        // this.querySelectorAll('.plan-box input').forEach(input => {
        //     input.addEventListener('click', (e) => {
        //         const subscribeRadio = this.querySelector('input[value="subscription"]');
        //         const isAllowed = this.totalQuantity >= this.minQuantity && subscribeRadio.checked;

        //         if (!isAllowed) {
        //             e.preventDefault(); // ❌ block selection
        //             return false;
        //         }

        //         // ✅ Proceed with selection
        //         this.querySelectorAll('.plan-box').forEach(box => box.classList.remove('active'));
        //         input.closest('.plan-box').classList.add('active');
        //         this.debouncedInjectBundleInputs();
        //         this.updateSubscribeDiscountText(); // 👈 add this

        //     });
        // });

        const input = this.querySelector('.plan-box input');
        if (input) {
            input.addEventListener('click', (e) => {
                const subscribeRadio = this.querySelector('input[value="subscription"]');
                const isAllowed = this.totalQuantity >= this.minQuantity && subscribeRadio.checked;

                if (!isAllowed) {
                    e.preventDefault(); // ❌ block selection
                    return false;
                }

                // ✅ Proceed with selection
                this.querySelectorAll('.plan-box').forEach(box => box.classList.remove('active'));
                input.closest('.plan-box').classList.add('active');
                this.debouncedInjectBundleInputs();
                this.updateSubscribeDiscountText();
            });
        }
    }

 applyPreselectFromURL() {
  const params = new URLSearchParams(window.location.search);
  let raw = params.get('pre-select');
  if (!raw) return;

  try { raw = decodeURIComponent(raw); } catch {}
  raw = String(raw).replace(/^['"]|['"]$/g, '');
  if (raw !== 'true') return;

  // 1) Pick the first product card
  const firstProduct = document.querySelector('.Meta_stitch_product_list_innerloops_mainboxs_new');
  if (!firstProduct) return;

  // 2) Ensure dynamic qty UI exists (simulate the “ADD FLAVOR” replace)
  let qtyBox = firstProduct.querySelector('.Meta_stitch_product_list_quantity_selector');
  if (!qtyBox) {
    const addBtn = firstProduct.querySelector('.Meta_stitch_product_list_add_flavor_new');
    if (addBtn) this.replaceWithQuantitySelector(addBtn); // creates the qty wrapper synchronously
    qtyBox = firstProduct.querySelector('.Meta_stitch_product_list_quantity_selector');
  }
  if (!qtyBox) return; // nothing to do

  // 3) Force quantity to 4 and keep internal counters/UI in sync
  const target = 4;
  const current = parseInt(qtyBox.dataset.quantity || '1', 10);
  qtyBox.dataset.quantity = String(target);
  const qtyText = qtyBox.querySelector('.quantity');
  if (qtyText) qtyText.textContent = String(target);

  this.totalQuantity += (target - current);
  firstProduct.classList.add('active');

  // 4) Recompute eligibility and prices
  this.checkSubscriptionEligibility();

  // 5) Auto-select “subscription” and the first plan (only after eligibility unlocks)
  const subscribeRadio = this.querySelector('input[value="subscription"]');
  if (subscribeRadio && !subscribeRadio.disabled) {
    subscribeRadio.checked = true;
    subscribeRadio.dispatchEvent(new Event('change', { bubbles: true })); // triggers your plan logic

    const firstPlanInput = this.querySelector('.plan-box input');
    if (firstPlanInput && !firstPlanInput.checked) {
      firstPlanInput.checked = true;
      // Click event to keep your current "plan box" handlers happy
      firstPlanInput.dispatchEvent(new Event('click', { bubbles: true }));
    }
  }

  // 6) Refresh totals / ATC label
  this.debouncedInjectBundleInputs();
  this.updateSubscribeDiscountText?.();
}



}

customElements.define('subscription-bundle', SubscriptionBundle);

function debounce(fn, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
    };
}
